var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rating-stars"},_vm._l((5),function(i){return _c('IconStart',{key:i,class:{ filled: _vm.stars >= i, half: _vm.stars > i - 1 && _vm.stars < i },attrs:{"id":`${i}_${_vm.randomNumbers}`}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }